import { render, staticRenderFns } from "./GameAnalyticsModal.vue?vue&type=template&id=9ac20620&scoped=true"
import script from "./GameAnalyticsModal.vue?vue&type=script&lang=js"
export * from "./GameAnalyticsModal.vue?vue&type=script&lang=js"
import style0 from "./GameAnalyticsModal.vue?vue&type=style&index=0&id=9ac20620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac20620",
  null
  
)

export default component.exports